import React from 'react';

export default function PrivacyPolicy() {
  const sections = [
    {
      num: "01",
      title: "Umumiy ma'lumot",
      content: (
        <>
          <p>Ushbu maxfiylik siyosati <strong>DevCore</strong> platformasi va ilovalari orqali to'planadigan hamda qayta ishlanadigan ma'lumotlarni tartibga soladi.</p>
          <p>Tizim Telegram ID va xavfsiz parol orqali autentifikatsiya qilish imkoniyatini beradi.</p>
        </>
      ),
    },
    {
      num: "02",
      title: "To'planadigan ma'lumotlar",
      content: (
        <ul className="list-disc pl-5">
          <li><strong>Telegram ID:</strong> Tizimga xavfsiz kirish va identifikatsiya qilish uchun.</li>
          <li><strong>Akademik ma'lumotlar:</strong> Talabaning joriy ballari, davomat (NB soatlari) ko'rsatkichlari.</li>
          <li><strong>Profil ma'lumotlari:</strong> Ism, familiya va boshqa shaxsiy profil elementlari.</li>
        </ul>
      ),
    },
    {
      num: "03",
      title: "Ma'lumotlardan foydalanish maqsadi",
      content: (
        <ul className="list-disc pl-5">
          <li>Talabaning akademik ko'rsatkichlari va reyting jadvalini yuritish.</li>
          <li>JWT tokenlari orqali foydalanuvchi shaxsini tasdiqlash va xavfsiz sessiyalarni boshqarish.</li>
          <li>Admin panel va bot orqali ta'lim jarayonini nazorat qilish hamda bildirishnomalar yuborish.</li>
        </ul>
      ),
    },
    {
      num: "04",
      title: "Ma'lumotlar xavfsizligi",
      content: (
        <p>Barcha maxfiy ma'lumotlar va parollar ma'lumotlar bazasida shifrlangan (Bcrypt) holda saqlanadi. Ma'lumotlaringiz uchinchi shaxslarga berilmaydi va qat'iy ravishda himoyalanadi.</p>
      ),
    },
    {
      num: "05",
      title: "Foydalanuvchi huquqlari",
      content: (
        <p>Siz o'z profilingiz ma'lumotlarini ko'rish, yangilash yoki tizimdan chiqish huquqiga egasiz. Tizimga kirishda xavfsizlik qoidalariga rioya qilishingiz talab etiladi.</p>
      ),
    },
    {
      num: "06",
      title: "Bog'lanish",
      content: (
        <p>Veb-sayt: <a href="https://dev-core.uz" className="underline text-indigo-600">dev-core.uz</a> <br /> 
           Telegram: <a href="https://t.me/DevCoreHR" className="underline text-indigo-600">@DevCoreHR</a></p>
      ),
    },
  ];

  return (
    <div className="max-w-2xl mx-auto px-6 py-12 font-sans text-gray-800">
      <header className="mb-10 border-b pb-6">
        <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
        <p className="text-sm text-gray-500 italic">So'nggi yangilanish: Sentyabr, 2026</p>
      </header>

      <main className="space-y-10">
        {sections.map((s) => (
          <section key={s.num}>
            <div className="flex items-center gap-4 mb-3">
              <span className="text-gray-400 font-mono text-sm">{s.num}</span>
              <h2 className="text-xl font-semibold">{s.title}</h2>
            </div>
            <div className="pl-9 space-y-3 text-base leading-relaxed text-gray-700">
              {s.content}
            </div>
          </section>
        ))}
      </main>

      <footer className="mt-16 text-center pt-6 border-t text-sm text-gray-500">
        <p>© {new Date().getFullYear()} DevCore Team. Barcha huquqlar himoyalangan.</p>
      </footer>
    </div>
  );
}